<template>
    <div>
        <h4>Keyword Blacklist</h4>
        <hr>
        <form v-on:submit.prevent="submit" class="mb-4">
            <div class="form-group">
                <label for="keyword">Keyword</label>
                <input 
                    type="text" 
                    class="form-control" 
                    id="keyword" 
                    v-model="form.keyword" 
                    placeholder="Contoh: spam, iklan, promo"
                    required
                >
                <small class="form-text text-muted">
                    Masukkan keyword yang akan memicu auto-blacklist. Jika pesan user mengandung keyword ini, nomor mereka akan otomatis masuk ke blacklist.
                </small>
            </div>
            <div class="form-group">
                <label for="match_type">Tipe Pencocokan</label>
                <select 
                    class="form-control" 
                    id="match_type" 
                    v-model="form.match_type"
                >
                    <option value="match">Match (mengandung keyword)</option>
                    <option value="exact">Exact Word (kata lengkap)</option>
                </select>
                <small class="form-text text-muted">
                    <strong>Match:</strong> Keyword akan terdeteksi jika muncul di mana saja dalam pesan.<br>
                    <strong>Exact Word:</strong> Keyword hanya terdeteksi jika muncul sebagai kata lengkap (dipisahkan spasi/tanda baca).
                </small>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary" :disabled="isLoading">
                    <span v-if="isLoading">Loading...</span>
                    <span v-else>Tambah</span>
                </button>
                <button type="button" class="btn btn-secondary ml-2" v-on:click="cancel">
                    Tutup
                </button>
            </div>
        </form>

        <hr class="my-4">

        <h5 class="mb-3">Daftar Keyword Blacklist</h5>
        <vue-good-table
            mode="remote"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            :totalRows="table.total_records"
            :isLoading.sync="table.isLoading"
            :pagination-options="{
                enabled: true,
                dropdownAllowAll: false,
                perPageDropdown: [10, 25, 50, 100],
            }"
            :columns="table.columns"
            :rows="table.rows"
        >
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <a
                        v-on:click="deleteKeyword(props.row.id)"
                        class="btn btn-danger text-white margin5"
                    >
                        Hapus
                    </a>
                </span>
                <span v-else-if="props.column.field == 'match_type'">
                    {{ props.row.match_type_display }}
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            form: {
                keyword: '',
                match_type: 'match'
            },
            isLoading: false,
            table: {
                total_records: 0,
                isLoading: true,
                columns: [
                    {
                        label: "Keyword",
                        field: "keyword",
                        filterOptions: {
                            enabled: true,
                            filterTrigger: 'auto',
                            placeholder: 'Cari keyword...',
                        },
                        sortable: false,
                        width: "30%",
                    },
                    {
                        label: "Match Type",
                        field: "match_type",
                        filterOptions: {
                            enabled: true,
                            filterTrigger: 'auto',
                            placeholder: 'Cari match type...',
                        },
                        sortable: false,
                        width: "20%",
                    },
                    {
                        label: "Tanggal Ditambahkan",
                        field: "created_at",
                        filterOptions: {
                            enabled: false,
                        },
                        sortable: false,
                        width: "30%",
                    },
                    {
                        label: "Action",
                        field: "action",
                        sortable: false,
                        width: "20%",
                    },
                ],
                rows: [],
                serverParams: {
                    columnFilters: {},
                    sort: [
                        {
                            field: "",
                            type: "",
                        },
                    ],
                    page: 1,
                    limit: 10,
                },
            },
        };
    },
    mounted() {
        this.fn = () => {
            this.loadItems();
        }
        this.$root.$on("refresh_keyword_table", this.fn);
        this.loadItems();
    },
    beforeDestroy() {
        this.$root.$off("refresh_keyword_table", this.fn);
    },
    methods: {
        async submit() {
            if (!this.form.keyword || this.form.keyword.trim() === '') {
                this.$toast.error('Keyword tidak boleh kosong');
                return;
            }

            this.isLoading = true;
            try {
                let response = await this.$store.dispatch("chatgpt_create_blacklist_keyword", {
                    id: this.id,
                    keyword: this.form.keyword,
                    match_type: this.form.match_type
                });
                this.$toast.success(response.data.message);
                this.form.keyword = '';
                this.form.match_type = 'match';
                this.loadItems();
            } catch (err) {
                this.$toast.error(err.response?.data?.message || "Gagal menambah keyword blacklist");
            }
            this.isLoading = false;
        },
        cancel() {
            this.form.keyword = '';
            this.form.match_type = 'match';
            this.$root.$emit("toggle_modal", "add_blacklist_keyword");
        },
        async deleteKeyword(keywordId) {
            if (!confirm('Yakin ingin menghapus keyword dari blacklist?')) {
                return;
            }
            try {
                let response = await this.$store.dispatch("chatgpt_delete_blacklist_keyword", {
                    id: this.id, 
                    keyword_id: keywordId
                });
                this.loadItems();
                this.$toast.success(response.data.message);
            } catch (err) {
                this.$toast.error(err.response?.data?.message || "Server error");
            }
        },
        updateParams(newProps) {
            this.table.serverParams = Object.assign(
                {},
                this.table.serverParams,
                newProps
            );
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({limit: params.currentPerPage});
            this.loadItems();
        },
        onSortChange(params) {
            this.updateParams({
                sort: [
                    {
                        type: params.sortType,
                        field: this.table.columns[params.columnIndex].field,
                    },
                ],
            });
            this.loadItems();
        },
        onColumnFilter(params) {
            this.table.serverParams.columnFilters = params.columnFilters || {};
            this.table.serverParams.page = 1;
            this.loadItems();
        },
        async loadItems() {
            this.table.isLoading = true
            try {
                let response = await this.getFromServer(this.table.serverParams);
                this.table.total_records = response.data.data.total_records;
                this.table.rows = response.data.data.keywords.map(item => ({
                    ...item,
                    match_type_display: item.match_type === 'exact' ? 'Exact Word' : 'Match',
                    created_at: this.formatDate(item.created_at)
                }));
            } catch (err) {
                this.$toast.error("Too many request");
            }
            this.table.isLoading = false
        },
        async getFromServer(param) {
            return await this.$store.dispatch("chatgpt_blacklist_keyword_list", {
                id: this.id,
                ...param
            });
        },
        formatDate(timestamp) {
            if (!timestamp) return '-';
            const date = new Date(timestamp);
            return date.toLocaleString('id-ID', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    }
};
</script>

<style scoped>
</style>


